export default __webpack_public_path__ + "static/media/nopendinginvite.cae27655.png";